import { DraftStatus, SortStatus } from './SetResponses';
import { DraftTrayResponse, TrayResponse } from './TrayResponses';

export enum OnboardingStatus {
  DRAFT = 'sato.draft',
  PENDING = 'sato.pending',
  APPROVED = 'sato.approved',
  REJECTED = 'sato.rejected',
  ARCHIVED = 'sato.archived',
  TODO = 'sato.todo',
}

export const onboardingStatus: Record<OnboardingStatus, DraftStatus> = {
  'sato.draft': DraftStatus.DRAFT,
  'sato.pending': DraftStatus.PENDING,
  'sato.approved': DraftStatus.APPROVED,
  'sato.rejected': DraftStatus.REJECTED,
  'sato.todo': DraftStatus.TODO,
  'sato.archived': DraftStatus.ARCHIVED,
};

export enum TrayOnboardingStatus {
  DRAFT = 'sato.draft',
  PENDING = 'sato.pending',
  APPROVED = 'sato.approved',
  REJECTED = 'sato.rejected',
  ARCHIVED = 'sato.archived',
  TODO = 'sato.todo',
  MODEL_CONFIG = 'sato.model_config',
  SKIPPED = 'sato.skipped',
}

export const trayOnboardingStatus: Record<TrayOnboardingStatus, DraftStatus> = {
  'sato.draft': DraftStatus.DRAFT,
  'sato.pending': DraftStatus.PENDING,
  'sato.approved': DraftStatus.APPROVED,
  'sato.rejected': DraftStatus.REJECTED,
  'sato.todo': DraftStatus.TODO,
  'sato.archived': DraftStatus.ARCHIVED,
  'sato.model_config': DraftStatus.REVIEW,
  'sato.skipped': DraftStatus.TODO,
};

export const sortStatus: Record<string, SortStatus> = {
  newest: SortStatus.NEWEST,
  oldest: SortStatus.OLDEST,
};

export interface SatoSetResponse {
  code: string;
  display_code: string;
  revision: string;
  region: string;
  group_desc: string;
  status?: OnboardingStatus;
  submitted_by?: string;
  submission_date?: string;
  trays: TrayResponse[];
  approved_date?: string;
  updated_by?: string;
  updated_date?: string;
  name?: string;

  /**
   * Draft set fetched from Firestore, as opposed to PostgreSQL DB.
   * Attached from API for convenience.
   */
  document?: DraftSatoSetResponse;
}

export interface SatoSetResponses {
  [id: string]: SatoSetResponse;
}

export interface DraftSatoSetResponse extends Omit<SatoSetResponse, 'document'> {
  kit_id: number;
  status: OnboardingStatus;
  sort: SortStatus;
  trays: DraftTrayResponse[];
  approved_date?: string;
}
